export const hasPermission = (sideMenu, route, actionName) =>
  sideMenu.some((menu) =>
    menu.pages.some(
      (page) =>
        page.route === route &&
        page.actions.some((action) => action.actionName === actionName && action.isChecked === '1')
    )
  );
